/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Create_DescriptionInputs */

const en_settings_overview_create_description = /** @type {(inputs: Settings_Overview_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload two photos to compose a shared stage and generate a rap video.`)
};

/**
* | output |
* | --- |
* | "Upload two photos to compose a shared stage and generate a rap video." |
*
* @param {Settings_Overview_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_overview_create_description = /** @type {((inputs?: Settings_Overview_Create_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Create_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_overview_create_description(inputs)
});
export { settings_overview_create_description as "settings.overview.create_description" }